import { Link } from "react-router-dom";

// const appURL = "/task-tracker";
const year = new Date().getFullYear();

const Footer = ({ appURL }) => {
  return (
    <footer className="copyright-container">
      <p>Copyright &copy; {year}</p>
      <Link to={appURL + "/about"}>about</Link>
    </footer>
  );
};

export default Footer;
